export default __webpack_public_path__ + "static/nmillard-9ac2e2656adb16e5e6c43f73a7d0f0d5.png";